import { createContext, Dispatch, SetStateAction, useState } from "react";

type metvProblem = {
  video: string;
  answer: string;
};

type metvProblem2 = {
  video: string;
  answer: string[];
};

type TStatusContext = {
  pageStatus: string;
  setPageStatus: Dispatch<SetStateAction<string>>;
  module: string;
  setModule: Dispatch<SetStateAction<string>>;
  isStartTest: boolean;
  setIsStartTest: Dispatch<SetStateAction<boolean>>;
  problems: number[];
  setProblems: Dispatch<SetStateAction<Array<number>>>;
  problemNumber: number;
  setProblemNumber: Dispatch<SetStateAction<number>>;
  mechanics: number;
  setMechanics: Dispatch<SetStateAction<number>>;
  engine: string;
  setEngine: Dispatch<SetStateAction<string>>;
  metvProblems: metvProblem[];
  setMetvProblems: Dispatch<SetStateAction<metvProblem[]>>;
  metvProblems2: metvProblem2[];
  setMetvProblems2: Dispatch<SetStateAction<metvProblem2[]>>;
  lang: string;
  setLang: Dispatch<SetStateAction<string>>;
  translations: any;
  setTranslations: Dispatch<SetStateAction<any>>;
};

export const StatusContext = createContext<TStatusContext>({
  pageStatus: "Welcome",
  setPageStatus: () => {},
  module: "",
  setModule: () => {},
  isStartTest: false,
  setIsStartTest: () => {},
  problems: [],
  setProblems: () => {},
  problemNumber: 0,
  setProblemNumber: () => {},
  mechanics: 0,
  setMechanics: () => {},
  engine: "menu",
  setEngine: () => {},
  metvProblems: [],
  setMetvProblems: () => {},
  metvProblems2: [],
  setMetvProblems2: () => {},
  lang: "en",
  setLang: () => {},
  translations: {},
  setTranslations: () => {},
});

export const StatusProvider = ({ ...props }) => {
  const { children } = props;
  const [pageStatus, setPageStatus] = useState<string>("Welcome");
  const [module, setModule] = useState<string>("");
  const [isStartTest, setIsStartTest] = useState<boolean>(false);
  const [problems, setProblems] = useState<number[]>([]);
  const [problemNumber, setProblemNumber] = useState<number>(0);
  const [mechanics, setMechanics] = useState<number>(0);
  const [engine, setEngine] = useState<string>("menu");
  const [metvProblems, setMetvProblems] = useState<metvProblem[]>([]);
  const [metvProblems2, setMetvProblems2] = useState<metvProblem2[]>([]);
  const [lang, setLang] = useState<string>("en");
  const [translations, setTranslations] = useState({});

  return (
    <StatusContext.Provider
      value={{
        pageStatus,
        setPageStatus,
        module,
        setModule,
        isStartTest,
        setIsStartTest,
        problems,
        setProblems,
        problemNumber,
        setProblemNumber,
        mechanics,
        setMechanics,
        engine,
        setEngine,
        metvProblems,
        setMetvProblems,
        metvProblems2,
        setMetvProblems2,
        lang,
        setLang,
        translations,
        setTranslations,
      }}
    >
      {children}
    </StatusContext.Provider>
  );
};
